export default __webpack_public_path__ + "static/media/Hek'lar's Cloak.13ffe255.jpg";